import React from 'react';
import PropTypes from 'prop-types';

import Cascader from 'rc-cascader';
import 'rc-cascader/assets/index.css';
import styled from 'styled-components';
import { InputGroup, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as _ from 'lodash';

import { getListChemistry } from 'api/lookuplistApi';

const ElementWrapper = styled.div`
  display: flex;
  .bp3-input-group {
    width: 100%;
  }
`;

export default class SelectLoaiChatThai extends React.Component {
  static propTypes = {
    initialvalue: PropTypes.any,
    onChange: PropTypes.func,
  };
  state = {
    isLoading: false,
    dataSource: [],
    inputValue: undefined,
  };
  componentDidMount = async () => {
    this.setState({
      isLoading: true,
    });
    const res = await getListChemistry();
    if (res.success) {
      const data = res.data;
      this.setState({
        dataSource: this.transferData(data),
        isLoading: false,
      });
    }
  };

  transferData = (data) => {
    return _.map(data, (item) => {
      const children = item.children;
      return {
        label: item.Name,
        value: item._id,
        moreInfo: item.moreInfo,
        children: _.map(children, (itemChildren) => {
          return {
            label: itemChildren.Name,
            value: itemChildren._id,
          };
        }),
      };
    });
  };

  handleOnChange = (value, selectedOptions) => {
    const temp = selectedOptions.map((o) => o.label).join(' / ');
    this.setState({
      inputValue: temp,
    });
    if (this.props.onChange) {
      this.props.onChange(selectedOptions);
    }
  };

  render() {
    const { dataSource, inputValue } = this.state;
    const { ...otherProps } = this.props;
    return (
      <ElementWrapper>
        {!this.state.isLoading && (
          <Cascader options={dataSource} onChange={this.handleOnChange}>
            <div style={{ width: '100%' }}>
              <InputGroup
                {...otherProps}
                placeholder='--Select--'
                value={inputValue ? inputValue : this.props.initialvalue}
                onChange={(event) => {
                  event.preventDefault();
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  right: 22,
                  top: '23%',
                  opacity: '0.3',
                }}
              >
                <Icon
                  icon={IconNames.CHEVRON_DOWN}
                />
              </div>
            </div>
          </Cascader>
        )}
      </ElementWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-loai-hoa-chat/index.js